import { createContext, useContext } from "react";
import { Table, type ColumnDef } from "@tanstack/react-table";

export const DataTableContext = createContext<{
  columns: ColumnDef<unknown>[];
  data: unknown[];
  table: Table<unknown> | null;
  currentPage?: number | null;
  totalPages?: number | null;
  isLoading?: boolean;
  numSkeletonRows?: number;
  renderedDimensions?: {
    contentDimensions: Record<string, { width: number; height: number }>;
  };
}>({
  columns: [],
  data: [],
  table: null,
  currentPage: null,
  totalPages: null,
  isLoading: false,
  numSkeletonRows: 5,
  renderedDimensions: { contentDimensions: {} },
});

export const useDataTableContext = () => {
  const context = useContext(DataTableContext);
  if (!context) {
    throw new Error(
      "useDataTableContext must be used within a DataTableProvider",
    );
  }
  return context;
};
